import { navigate } from '@reach/router'
import { RootState } from 'context'
import { setFirtsLoad } from 'context/reducer/app'
import { useEffect, useState } from 'react'
import { URL_PATH } from 'utils/global'
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from 'interfaces/app'

interface Props {
  flujo: string
  pathname: string
}

const useGetPath = ({ flujo, pathname }: Props) => {
  const { isFirstLoad } = useSelector<RootState, AppState>(state => state.app)
  const dispatch = useDispatch()
  const [path, setPath] = useState('')
  useEffect(() => {
    const newpath = pathname
      .replace(`/${flujo}/login/`, '')
      .replace(`/${flujo}/login`, '')
    if (['otp', 'otp/', 'solicitud'].includes(newpath) && isFirstLoad) {
      navigate(URL_PATH())
    } else {
      dispatch(setFirtsLoad())
    }
    setPath(newpath)
  }, [dispatch, flujo, pathname, isFirstLoad])
  return path
}

export default useGetPath
